export const prefixUrl = "";
export const addonUiUrl = "/addon/ui";
